{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2024                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCCustomDialog;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}

interface

uses
  Classes, UITypes, WEBLib.Controls, WEBLib.Forms,
  {$IFDEF FMXLIB}
  FMX.Types,
  {$ENDIF}
  WEBLib.TMSFNCCustomComponent, WEBLib.TMSFNCCustomControl;

type
  {$IFDEF FMXLIB}
  TTMSFNCCustomDialogParent = TFmxObject;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCCustomDialogParent = TWinControl;
  {$ENDIF}

  TTMSFNCCustomDialog = class(TTMSFNCCustomComponent)
  private
    FFrm: TTMSFNCCustomDesignerForm;
    FControl: TControl;
    FDialogHeight: Integer;
    {$IFNDEF WEBLIB}
    FCaption: string;
    {$ENDIF}
    FDialogWidth: Integer;
    FOnClose: TNotifyEvent;
    FAllowReturnKeyClose: Boolean;
    procedure SetControl(const Value: TControl);
    {$IFNDEF WEBLIB}
    procedure SetDialogCaption(const Value: string);
    {$ENDIF}
    procedure SetDialogHeight(const Value: Integer);
    procedure SetDialogWidth(const Value: Integer);
  protected
    function GetInstance: NativeUInt; override;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    procedure DoFormClose(Sender: TObject; var AAction: TCloseAction);
    procedure DoClose; virtual;
    procedure DoFormShow(Sender: TObject); virtual;
    {$IFNDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    {$ENDIF}
    {$IFDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    {$ENDIF}
    procedure BuildDialog(AParent: TTMSFNCCustomDialogParent); virtual;
	procedure ScaleForCurrentDPI(AForm: TCustomForm);
    property Form: TTMSFNCCustomDesignerForm read FFrm;
    property Control: TControl read FControl write SetControl;
    {$IFNDEF WEBLIB}
    property Caption: string read FCaption write SetDialogCaption;
    {$ENDIF}
    property AllowReturnKeyClose: Boolean read FAllowReturnKeyClose write FAllowReturnKeyClose;
    property DialogWidth: Integer read FDialogWidth write SetDialogWidth;
    property DialogHeight: Integer read FDialogHeight write SetDialogHeight;
    property OnClose: TNotifyEvent read FOnClose write FOnClose;
  public
    constructor Create(AOwner: TComponent); override;
    {$IFDEF WEBLIB}
    procedure Execute(AProc: TModalResultProc = nil);
    {$ELSE}
    function Execute: TModalResult;
    {$ENDIF}
  end;

  TTMSFNCCustomDialogForm = class(TTMSFNCCustomDesignerForm)
  {$IFDEF WEBLIB}
  private
    FCustomDialog: TTMSFNCCustomDialog;
  protected
    procedure Loaded; override;
    procedure LoadDFMValues; override;
  public
    constructor CreateDialogNew(ACustomDialog: TTMSFNCCustomDialog; ACaption: string); reintroduce; virtual;
  {$ENDIF}
  end;

implementation

uses
  {$IFDEF VCLLIB}
  Vcl.Graphics,
  {$ENDIF}
  WEBLib.TMSFNCUtils, WEBLib.TMSFNCTypes;

{ TTMSFNCCustomDialogForm }

{$IFDEF WEBLIB}
constructor TTMSFNCCustomDialogForm.CreateDialogNew(
  ACustomDialog: TTMSFNCCustomDialog; ACaption: string);
begin
  FCustomDialog := ACustomDialog;
  inherited CreateDialogNew(ACaption);
end;

procedure TTMSFNCCustomDialogForm.LoadDFMValues;
begin
  inherited LoadDFMValues;
  if Assigned(FCustomDialog) then
  begin
    FCustomDialog.BuildDialog(Self);
    //ActiveControl := FBitmapEditor.FTopPanel;
  end;
end;

procedure TTMSFNCCustomDialogForm.Loaded;
var
  css: string;
begin
  inherited;

  css := Application.IDECSS;

  if (css <> '') then
  begin
    AddCSS('IDECSS', css);
    ElementClassName := 'IDEBkg';
    CaptionElement['class'] := 'IDECaption IDEFont';
    //if Assigned(FCustomDialog) then
      //FCustomDialog.ApplyCSS(css);
  end;
end;
{$ENDIF}

{ TTMSFNCCustomDialog }

procedure TTMSFNCCustomDialog.BuildDialog(AParent: TTMSFNCCustomDialogParent);
begin
  //
end;

constructor TTMSFNCCustomDialog.Create(AOwner: TComponent);
begin
  inherited;
  FDialogWidth := 440;
  FDialogHeight := 300;
end;

procedure TTMSFNCCustomDialog.DoClose;
begin
  if Assigned(OnClose) then
    OnClose(Self);
end;

procedure TTMSFNCCustomDialog.DoFormClose(Sender: TObject; var AAction: TCloseAction);
begin
  DoClose;
end;

{$IFNDEF FMXLIB}
procedure TTMSFNCCustomDialog.DoFormKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
{$ENDIF}
{$IFDEF FMXLIB}
procedure TTMSFNCCustomDialog.DoFormKeyDown(Sender: TObject; var Key: Word;
  var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
begin
  if Key = KEY_ESCAPE then
  begin
    FFrm.Close;
  end
  else if Key = KEY_RETURN then
  begin
    if FAllowReturnKeyClose then
    begin
      FFrm.ModalResult := mrOk;
      {$IFNDEF FMXLIB}
      FFrm.Close;
      {$ENDIF}
      {$IFDEF FMXLIB}
      FFrm.CloseModal;
      {$ENDIF}
    end;
  end;
end;

procedure TTMSFNCCustomDialog.DoFormShow(Sender: TObject);
begin
  //
end;

{$IFDEF WEBLIB}
procedure TTMSFNCCustomDialog.Execute(AProc: TModalResultProc = nil);
{$ELSE}
function TTMSFNCCustomDialog.Execute: TModalResult;
{$ENDIF}
begin
  {$IFDEF WEBLIB}
  FFrm := TTMSFNCCustomDialogForm.CreateDialogNew(Self, Caption);
  {$ELSE}
  FFrm := TTMSFNCCustomDialogForm.CreateNew(Application);
  FFrm.OnClose := DoFormClose;
  FFrm.OnShow := DoFormShow;
  FFrm.OnKeyDown := @DoFormKeyDown;
  FFrm.Caption := Caption;
  {$ENDIF}
  FFrm.ClientWidth := DialogWidth;
  FFrm.ClientHeight := DialogHeight;
  {$IFDEF FMXLIB}
  FFrm.Position := TFormPosition.ScreenCenter;
  FFrm.BorderStyle := TFmxFormBorderStyle.Single;
  FFrm.BorderIcons := [TBorderIcon.biSystemMenu, TBorderIcon.biMinimize];
  //FFrm.Fill.Kind := TBrushKind.Solid;
//  if IsLightTheme then
//    FFrm.Fill.Color := EDITORSUBBACKCOLORLIGHT
//  else
//    FFrm.Fill.Color := EDITORSUBBACKCOLORDARK;
  {$ENDIF}
  {$IFDEF CMNLIB}
  FFrm.KeyPreview := True;
  FFrm.BorderStyle := bsSingle;
  FFrm.BorderIcons := [biSystemMenu, biMinimize];
  {$ENDIF}

  {$IFDEF CMNWEBLIB}
  FFrm.Position := poScreenCenter;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  BuildDialog(FFrm);
  {$ENDIF}
  {$IFDEF FMXLIB}
  FFrm.AfterConstruction;
  {$ENDIF}
  ScaleForCurrentDPI(FFrm);
  {$IFDEF VCLLIB}
  FFrm.ClientHeight := Round(FDialogHeight * TTMSFNCUtils.GetDPIScale(FFrm, 96));
  {$ENDIF}
  {$IFNDEF WEBLIB}
  Result := FFrm.ShowModal;
  FFrm.Free;
  {$ELSE}
  FFrm.ShowModal(
  procedure(AResult: TModalResult)
  begin
    FFrm := nil;
    if Assigned(AProc) then
      AProc(AResult);
  end);
  {$ENDIF}
end;

function TTMSFNCCustomDialog.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

procedure TTMSFNCCustomDialog.Notification(AComponent: TComponent;
  AOperation: TOperation);
begin
  inherited;
  if (AOperation = opRemove) and (AComponent = FControl) then
    FControl := nil;
end;

{$IFDEF VCLLIB}
type
  TDPIControlProtected = class(TControl);
  TDPICustomFormProtected = class(TCustomForm);
{$ENDIF}

procedure TTMSFNCCustomDialog.ScaleForCurrentDPI(AForm: TCustomForm);
{$IFDEF VCLLIB}
{$HINTS OFF}
{$IF COMPILERVERSION >= 33}
var
  sc: Single;

  procedure ScaleControlsForCurrentDPI(AControl: TControl);
  var
    I: Integer;
    cw: TWinControl;
    c: TDPIControlProtected;
  begin
    if AControl is TWinControl then
    begin
      cw := (AControl as TWinControl);
      for I := 0 to cw.ControlCount - 1 do
        ScaleControlsForCurrentDPI(cw.Controls[I]);
    end;

    if (AControl is TControl) and not (AControl is TCustomForm) then
    begin
      c := TDPIControlProtected(AControl);
      c.Font.Height := TTMSFNCUtils.MulDivInt(c.Font.Height, 96, c.Font.PixelsPerInch);
    end;
  end;
{$IFEND}
{$HINTS ON}
{$ENDIF}
begin
  if Assigned(AForm) then
  begin
    {$IFDEF VCLLIB}
    {$HINTS OFF}
    {$IF COMPILERVERSION >= 33}
    ScaleControlsForCurrentDPI(AForm);
    TDPICustomFormProtected(AForm).ScaleForCurrentDPI;
    if AForm.ClassName = 'TTMSFNCCustomPopupForm' then
       Exit;

    sc := TTMSFNCUtils.GetDPIScale(AForm, 96);
    AForm.ClientWidth := Round(AForm.ClientWidth * sc);
    AForm.ClientHeight := Round(AForm.ClientHeight * sc);
    {$IFEND}
    {$HINTS ON}
    {$ENDIF}
  end;
end;

{$IFNDEF WEBLIB}
procedure TTMSFNCCustomDialog.SetDialogCaption(const Value: string);
begin
  if FCaption <> Value then
  begin
    FCaption := Value;
    if Assigned(FFrm) then
      FFrm.Caption := Value;
  end;
end;
{$ENDIF}

procedure TTMSFNCCustomDialog.SetControl(const Value: TControl);
begin
  if FControl <> Value then
    FControl := Value;
end;

procedure TTMSFNCCustomDialog.SetDialogHeight(const Value: Integer);
begin
  if FDialogHeight <> Value then
  begin
    FDialogHeight := Value;
    if Assigned(FFrm) then
    begin
      {$IFDEF VCLLIB}
      FFrm.ClientHeight := Round(Value * TTMSFNCUtils.GetDPIScale(FFrm, 96));
      {$ENDIF}
      {$IFNDEF VCLLIB}
      FFrm.ClientHeight := Value;
      {$ENDIF}
    end;
  end;
end;

procedure TTMSFNCCustomDialog.SetDialogWidth(const Value: Integer);
begin
  if FDialogWidth <> Value then
  begin
    FDialogWidth := Value;
    if Assigned(FFrm) then
    begin
      {$IFDEF VCLLIB}
      FFrm.ClientWidth := Round(Value * TTMSFNCUtils.GetDPIScale(FFrm, 96));
      {$ENDIF}
      {$IFNDEF VCLLIB}
      FFrm.ClientWidth := Value;
      {$ENDIF}
    end;
  end;
end;

end.
